import React, { Component } from "react";
import { message, Divider, Input, Icon, Button, Typography, Radio } from "antd";
import user from "../store/soap/user.js";

const { Title } = Typography;

export default class NewUser extends Component {
  state = {
    centros: [],
    centros_select: [],
    userName: "",
    password: "",
    matricula: "",
    email: "",
    role: "user",
    load: true,
    value: undefined,
  };

  async componentDidMount() {}

  salveUser = async (e) => {
    try {
      message.loading("Cadastrando...");
      await user.createUser({
        email: this.state.email,
        password: this.state.password,
        name: this.state.userName,
        matricula: this.state.matricula,
        role: this.state.role,
        phone: "(31) 90000-0000",
      });
      message.success("Usuário cadastrado com sucesso.");
      this.setState({
        userName: "",
        password: "",
        matricula: "",
        email: "",
        role: "user",
      });
    } catch (error) {
      const { response } = error;
      if (response.data.message) {
        return message.warning(response.data.message);
      }
      message.warning("Error, tente novamente.");
    }
  };

  handleChange = (value) => {
    this.setState({ value });
  };

  onChangeEmail = (e) => {
    this.setState({ email: e.target.value });
  };

  onChangeUserName = (e) => {
    this.setState({ userName: e.target.value });
  };

  onChangeMatricula = (e) => {
    this.setState({ matricula: e.target.value });
  };

  onChangePassword = (e) => {
    this.setState({ password: e.target.value });
  };

  onChangeRole = (e) => {
    this.setState({ role: e.target.value });
  };

  render() {
    const { userName, password, email, matricula, role } = this.state;
    const plainOptions = ["user", "admin"];

    return (
      <>
        <Title level={3}>Cadastrar usuário</Title>

        <Divider orientation="left">E-mail:</Divider>
        <Input
          placeholder="Email"
          type="email"
          size="large"
          prefix={<Icon type="mail" style={{ color: "rgba(0,0,0,.25)" }} />}
          value={email}
          onChange={this.onChangeEmail}
        />

        <Divider orientation="left">Senha:</Divider>
        <Input
          placeholder="Senha"
          size="large"
          prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
          value={password}
          onChange={this.onChangePassword}
        />

        <Divider orientation="left">Nome de usuário:</Divider>
        <Input
          placeholder="Usuário"
          size="large"
          prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
          value={userName}
          onChange={this.onChangeUserName}
        />

        <Divider orientation="left">Matrícula DMA:</Divider>
        <Input
          placeholder="Matrícula"
          size="large"
          prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
          value={matricula}
          onChange={this.onChangeMatricula}
        />

        <Divider orientation="left">Permissão de acesso</Divider>
        <Radio.Group
          options={plainOptions}
          onChange={this.onChangeRole}
          value={role}
        />

        <Button
          type="primary"
          icon="check"
          size="large"
          block
          style={{ marginTop: 20 }}
          onClick={this.salveUser}
          className="dma-primary"
        >
          SALVAR
        </Button>
      </>
    );
  }
}
